import { render, staticRenderFns } from "./salary card.vue?vue&type=template&id=71b3fe0e&scoped=true"
import script from "./salary card.vue?vue&type=script&lang=js"
export * from "./salary card.vue?vue&type=script&lang=js"
import style0 from "./salary card.vue?vue&type=style&index=0&id=71b3fe0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3fe0e",
  null
  
)

export default component.exports